import { render, staticRenderFns } from "./InsuranceDetails.vue?vue&type=template&id=745d9684&scoped=true&"
import script from "./InsuranceDetails.vue?vue&type=script&lang=js&"
export * from "./InsuranceDetails.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceDetails.vue?vue&type=style&index=0&id=745d9684&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745d9684",
  null
  
)

export default component.exports